module.exports = __webpack_public_path__ + "static/media/more.a4132e53.svg";